import React from 'react'

import { loadBusinessData } from '@disco/state-management/actions/UserActions'
import { getUser } from '@disco/state-management/selectors/user'

import ChargebeePricingEmbed from 'components/chargebee-pricing-embed'
import { ADMIN_ONLY_MESSAGE } from 'components/common/your-subscription/utils'
import { Text } from 'components/ds'
import PageContainer from 'components/ui/page-container'

import useEventListener from 'hooks/use-event-listener'
import { useInterval } from 'hooks/use-interval'
import { useDispatch, useSelector } from 'hooks/use-redux'

const RELOAD_INTERVAL_MS = 10 * 1000

/** Lets an admin on a running trial choose a plan on the embedded Chargebee pricing page. */
const TrialSignup = (): React.ReactNode => {
  const dispatch = useDispatch()
  const user = useSelector(getUser)
  const isAdmin = Boolean(
    user.permissions?.includes('can_change_business_settings'),
  )

  // Chargebee doesn't tell the page about payment, and checkout finishes in another tab or device
  const reloadBusiness = () => {
    if (document.hidden) return
    dispatch(loadBusinessData('WITHOUT_REALTIME_TRACK_COUNT'))
  }
  useInterval(reloadBusiness, RELOAD_INTERVAL_MS)
  useEventListener('visibilitychange', reloadBusiness, document)

  return (
    <PageContainer>
      {/* the backend refuses a non-admin the trial_signup pricing page */}
      {isAdmin ? (
        <ChargebeePricingEmbed />
      ) : (
        <Text as="p" size="2">
          {ADMIN_ONLY_MESSAGE}
        </Text>
      )}
    </PageContainer>
  )
}

export default TrialSignup
